/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { styles } from '../posShared.styles';
import { modalExperience } from '../../../shared/modals/modalExperience.styles';
import { OperationalHintIcon } from '../../../shared/ui/OperationalHintIcon';
import type { CartPromoUiStatus } from '../../application/posCartPromoPresentation';

type Props = {
  cashSessionOpen: boolean | null;
  onOpenCashManagement?: () => void;
  cashManagementAccessBlockedHint?: string;
  promoUiStatus?: CartPromoUiStatus;
};

export function PosCheckoutAlertsBand({
  cashSessionOpen,
  onOpenCashManagement,
  cashManagementAccessBlockedHint,
  promoUiStatus,
}: Props) {
  const showCashClosed = cashSessionOpen === false;
  const showPromoStale = promoUiStatus?.hasStaleSelection === true;
  if (!showCashClosed && !showPromoStale) return null;

  return (
    <View style={styles.checkoutAlertsBand}>
      {showPromoStale ? (
        <View style={styles.checkoutHeroAlerts}>
          <OperationalHintIcon
            title="Promoción"
            message={promoUiStatus?.staleMessage ?? 'Esta promo ya no vale'}
            severity="warning"
            size={16}
            testID="pos-checkout-promo-stale-hint"
          />
        </View>
      ) : null}
      {showCashClosed ? (
        <View style={modalExperience.warningPanel}>
          <Text style={styles.readOnlyText}>
            Caja cerrada. Para cobrar en efectivo, abrí el turno.
          </Text>
          {onOpenCashManagement ? (
            <TouchableOpacity
              onPress={onOpenCashManagement}
              accessibilityRole="button"
              accessibilityLabel="Abrir caja"
            >
              <Text style={[styles.linkText, { marginTop: spacing.xs }]}>Abrir caja</Text>
            </TouchableOpacity>
          ) : cashManagementAccessBlockedHint ? (
            <Text style={[styles.readOnlyText, { marginTop: spacing.xs }]}>
              {cashManagementAccessBlockedHint}
            </Text>
          ) : null}
        </View>
      ) : null}
    </View>
  );
}
